import React from "react";

import "./Accessibility.css";

export default function Accessibility(props) {
  let accessibility = props.accessibility;
  let accessibilityList = accessibility.map((error, index) => {
    return (
      <li key={"error-" + index}>
        <h5 className="error-heading">{error.help}</h5>
        <a
          href={error.helpUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="error-url"
        >
          {error.helpUrl}
        </a>
        <h5 className="node-list-heading">Relevant html elements</h5>
        <ul>
          {error.nodes.map((node, index) => {
            return (
              <li key={"html-el-" + index} className="node-list-item">
                {node.html}
              </li>
            );
          })}
        </ul>
      </li>
    );
  });

  return (
    <div className="accessibility">
      <h2>Accessibility suggestions</h2>
      <ul>{accessibilityList}</ul>
    </div>
  );
}
